export default "__VITE_ASSET__DGGi_ijF__"